import { ASTROLIBRARY_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';
import React from 'react';

const AstroLibrary = () => {
  return (
    <div
      id='content-AstroLibrary'
      className='w-full h-full flex flex-col box-border gap-4 xl:gap-6 relative'
    >
      {/* Desktop Image */}
      <img
        src={VIDEO_URLS.ASTRO_LIBRARY}
        alt='AstroLibrary'
        className='hidden xl:block absolute top-auto left-[65%] translate-x-0 translate-y-0 w-80 h-80 object-cover pointer-events-none z-20 rounded-full'
      />
      <div className='hidden xl:block absolute top-[85%] left-[67%] w-[360px] justify-center z-30 pointer-events-none'>
        <p
          className='text-[#949494] text-3xl font-medium bg-black/70 px-4 py-2 rounded-lg'
          style={{
            boxShadow: '0px 0px 8px 0px #000000BF',
            fontFamily: 'Noto Serif',
          }}
        >
          Reinvent the Wheel?
        </p>
      </div>

      <div className='flex flex-col gap-4 md:gap-6 relative z-20 xl:w-[600px] xl:h-[400px] md:h-[350px]'>
        <div className='w-full flex flex-col justify-start px-4 md:px-0'>
          <h1 className='leading-7 md:leading-8 text-4xl md:text-4xl font-bold text-white text-left'>
            <strong>
              Astro-<span className='text-[#fccb15]'>L</span>ibrary
            </strong>
          </h1>
        </div>
        <div className='border-l-4 border-[#FCCB16] md:pl-3 ml-4 md:ml-0'>
          <div className='text-base md:text-lg font-medium text-white md:text-justify xl:hidden px-4 md:px-0'>
            {ASTROLIBRARY_CONTEXT.SUBTITLE}
          </div>
          <div className='hidden xl:block text-lg font-medium text-white text-justify'>
            {ASTROLIBRARY_CONTEXT.SUBTITLE.split('development').map(
              (part, index) => (
                <p key={index}>
                  {index === 0 ? part + 'development' : part.trim()}
                </p>
              )
            )}
          </div>
        </div>
        <div className='w-full flex justify-start items-start px-4 md:px-0'>
          <section className='w-full flex justify-start'>
            <div className='text-sm md:text-lg font-medium text-white md:text-justify'>
              {ASTROLIBRARY_CONTEXT.DESCRIPTION}
            </div>
          </section>
        </div>
        <div className='md:hidden flex flex-col items-center relative'>
          <div className='relative w-[calc(100%+2rem)] h-[319px] overflow-hidden rounded-lg -mx-4'>
            <img
              src={VIDEO_URLS.ASTRO_LIBRARY}
              alt='AstroLibrary'
              className='w-48 h-48 md:w-[300px] md:h-[300px] left-[23%] top-[10%] object-cover pointer-events-none rounded-full absolute'
            />
          </div>
          <div className='md:hidden w-full flex mt-4 absolute bottom-[40px] justify-center z-30 pointer-events-none'>
            <p
              className='text-[#949494] md:text-[36px] text-xl font-medium bg-black/70 px-3 py-1.5 rounded-lg'
              style={{
                fontFamily: 'Noto Serif',
              }}
            >
              Reinvent the Wheel?
            </p>
          </div>
        </div>
      </div>

      {/* Mobile & Tablet Image */}
      <div className='xl:hidden hidden md:flex flex-col items-center gap-4 mt-8'>
        <div className='relative w-full h-[350px] overflow-hidden rounded-lg flex items-center justify-center'>
          <img
            src={VIDEO_URLS.ASTRO_LIBRARY}
            alt='AstroLibrary'
            className='w-48 h-48 md:w-[300px] md:h-[300px] object-cover pointer-events-none rounded-full'
          />
        </div>
        <div className='w-full flex justify-center z-30 pointer-events-none'>
          <p
            className='text-[#949494] md:text-[36px] text-xl font-medium bg-black/70 px-3 py-1.5 rounded-lg'
            style={{
              fontFamily: 'Noto Serif',
            }}
          >
            Reinvent the Wheel?
          </p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AstroLibrary);
